import request from "root/js/request";

const getStorageAndAcceptanceTopProducts = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  category_id__in,
  brand_id__in,
  value,
  subject_id__in,
  product_id__in,
}) => {
  const response = await request({
    url: "/analytics/paid_storage_top_products/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      value,
      subject_id__in,
      product_id__in,
    },
  });
  return response.data;
};

export { getStorageAndAcceptanceTopProducts };
